import type { ReactNode} from 'react';
import { useMemo } from 'react';

import { cn } from '@ui/uikit/utils';

import { MarkInfo } from '../../icons/mono/MarkInfo';
import type { TooltipContentProps, TooltipProps } from './Tooltip';
import { Tooltip } from './Tooltip';

export type InfoTooltipProps<Content = ReactNode> = Omit<TooltipProps, 'trigger'> & {
  triggerClassName?: string;
} & TooltipContentProps<Content>;

export const InfoTooltip = ({ triggerClassName, ...props }: InfoTooltipProps) => {
  const ariaLabel = useMemo(() => {
    return 'caption' in props ? props.caption : props.message;
  }, [props]);

  return (
    <Tooltip
      {...(props as TooltipProps)}
      trigger={
        <button
          type="button"
          className={cn('tooltip-button tooltip-button-sm', triggerClassName)}
          aria-label={typeof ariaLabel === 'string' ? ariaLabel : undefined}
        >
          <MarkInfo className="tooltip-icon" />
        </button>
      }
    />
  );
};
